"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AddressCardText;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ui = require("@unite-us/ui");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function AddressCardText(props) {
  var location = props.location,
    serviceAreaText = props.serviceAreaText,
    className = props.className,
    iconColor = props.iconColor;
  var icon = serviceAreaText ? 'IconRadar' : 'IconMapMarkV2';
  var title = serviceAreaText || location.displayName;
  var text = serviceAreaText || "".concat(location.displayName, " (").concat(location.distance, ")");
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])({
      'address-card-text': true,
      'detail-card-text': true
    }, className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "detail-card-text__location"
  }, /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
    className: "detail-card-text__icon mr-half",
    color: iconColor,
    icon: icon
  }), /*#__PURE__*/_react["default"].createElement("p", {
    title: title
  }, text)));
}
AddressCardText.propTypes = {
  /** className */
  className: _propTypes["default"].string,
  /** location object via displayName and distance */
  location: _propTypes["default"].object,
  /** icon color */
  iconColor: _propTypes["default"].string,
  /** text describing the service area */
  serviceAreaText: _propTypes["default"].string
};
AddressCardText.defaultProps = {
  location: {},
  className: '',
  iconColor: '#67859E',
  serviceAreaText: null
};